import { Gauge, ShieldAlert, Sparkles } from 'lucide-react'
import { type ReactNode } from 'react'

import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'
import { type SalesLead } from '@/models/salesLead'
import { CollapsibleSection } from './CollapsibleSection'
import { ConversionScoreSection } from './ConversionScoreSection'
import { NextBestActionSection } from './NextBestActionSection'
import { SafetySection } from './SafetySection'

function SubHeading({
  icon: Icon,
  className,
  children,
}: {
  icon: typeof Gauge
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn('flex items-center gap-2 text-sm font-semibold', className)}>
      <Icon className="size-4 shrink-0" />
      {children}
    </div>
  )
}

export function LeadInsightsCard({ lead, className }: { lead: SalesLead; className?: string }) {
  return (
    <Card className={className}>
      <CardContent>
        <CollapsibleSection fadeClassName="from-blue-50">
          <div className="space-y-5">
            <div className="space-y-2">
              <SubHeading icon={ShieldAlert} className="text-base">
                Safety
              </SubHeading>
              <SafetySection safetyScore={lead.safetyScore} />
            </div>
            <Separator />
            <div className="mt-5">
              <ConversionScoreSection
                score={lead.conversionScore}
                factors={lead.scoreFactors}
                reasoning={lead.scoreReasoning}
                updatedAt={lead.scoreUpdatedAt}
              />
            </div>
            <Separator />
            <div className="mt-5 space-y-2">
              <SubHeading icon={Sparkles}>Next best action</SubHeading>
              <NextBestActionSection recommendation={lead.recommendation} />
            </div>
          </div>
        </CollapsibleSection>
      </CardContent>
    </Card>
  )
}
